<script>
export default {
  created () {
    this.$store.dispatch('modal/open', {
      name: 'email-request-modal'
    })
  }
}
</script>
